export enum RetrievalType {
  USERNAME = 'username',
  PASSWORD = 'password'
}
